import TestCaseResult from 'src/containers/TestCaseResult/TestCaseResult';

export default TestCaseResult;